export class UserTagRequest {
    userId : number;
    tagIds : number[];

    constructor() {
        this.userId = 0;
        this.tagIds = [];
    }
}